// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"18a5ac8d","323":"89904cc8","619":"2111fcde","705":"d604a71e","717":"256ac1aa","734":"31d6cfe0","735":"6ab9f5ee","922":"6ce01875"}[chunkId] + ".chunk.css";
};